import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

import { MaintenanceMailboxRulesComponent } from "./maintenance-mailbox-rules.component";

const routesMailBox: Routes = [
  {
    path: "",
    component: MaintenanceMailboxRulesComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesMailBox)],
  exports: [RouterModule],
})
export class MailBoxRoutingModule {}
